export default __webpack_public_path__ + "static/media/gistdrystamp.aef21e5e.png";